import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

import type Board from 'webapp/models-custom/board';

export default class BoardsViewBoardPreviewRoute extends Route {
	@service('model-manager/boards') declare mmBoardsService: Service.ModelManager.Boards;
	@service('navigation') declare navigationService: Service.Navigation;

	override model(): Board | undefined {
		return this.modelFor('boards.view.board') as Board | undefined;
	}

	override afterModel(model: Board | undefined): void {
		this.navigationService.replaceRoute('boards.index').then(() => {
			if (model) {
				this.mmBoardsService.openPreview(model);
			}
		});
	}
}
